import { defineMessages } from "react-intl";

export const SCAN_BOX_LABELS = defineMessages({
  message: {
    id: "crossdock.boxBreakScanBoxCard.message",
    defaultMessage: "Please scan any box to start breaking",
  },
});
